import { render, staticRenderFns } from "./CorrespondenceItemForm.vue?vue&type=template&id=08fd7988"
import script from "./CorrespondenceItemForm.vue?vue&type=script&lang=js"
export * from "./CorrespondenceItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports